import { Injectable } from '@angular/core';

declare var window: any;

@Injectable()
export class DatabaseServiceProvider {

	public db: any;
	public dbname: string = 'vendamais.db';

	constructor() { 

		this.db = window.openDatabase(this.dbname, '1.0', 'Test DB', -1);

		this.db.transaction(function(tx) {
			tx.executeSql("CREATE TABLE IF NOT EXISTS SB1 (B1_COD VARCHAR(6), B1_DESC VARCHAR(60))", [], console.info("Your table created successfully"), console.error("Error while creating the tables"));
			tx.executeSql("INSERT INTO SB1 (B1_COD, B1_DESC) VALUES ('000001','TESTE')", [], console.info("Your table created successfully"), console.error("Error while creating the tables"));
		});
		
		//this.db.executeSql('CREATE TABLE IF NOT EXISTS SB1 (B1_COD VARCHAR(6), B1_DESC VARCHAR(60))');

        console.info("--> running in browser: ", this.db);
        
    }

	/**
	 * Init - init database etc. PS! Have to wait for Platform.ready
	 */
    
/*	init(): Promise<any> {
		return new Promise(resolve => {
			if (typeof window.sqlitePlugin !== 'undefined') {
				this.db = window.sqlitePlugin.openDatabase({ name: this.dbname, location: 'default' });
				console.info("--> running on device: ", this.db);
				resolve();
			} else {
				this.db = window.openDatabase(this.dbname, '1.0', 'Test DB', -1);
				console.info("--> running in browser: ", this.db);
				resolve();
			};
		});
	}*/

	/**
	 * query - executes sql
	 */
    /*
	query(q: string, params?: any): Promise<any> {
		return new Promise((resolve, reject) => {
			params = params || [];
			this.db.transaction((tx) => {
				tx.executeSql(q, params, (tx, res) => {
					resolve(res);
				}, (tx, err) => {
					reject(err);
				});
			});
		});
	}*/
}


// WEBPACK FOOTER //
// ./src/providers/database-service.ts